import React from 'react'

import CardBody from '../../../../UI/Card/Body/Body'
import { Grid } from '@material-ui/core'

import EmpProfile from './EmpProfile/EmpProfile'
import EmpPositions from './EmpPositions/EmpPositions'

const empDetailBody = ({
  forms,
  inputChanged,
  empPositions,
  positionInputChanged,
  addRowClicked,
  deleteRowClicked,
  actionToClicked,
  delegateClicked,
  imageSrc,
  dropdownOptions,
  edit,
  primaryRowIndex
}) => {
  return (
    <CardBody>
      <Grid container spacing={2}>
        <Grid container item spacing={1}>
          <EmpProfile
            forms={forms}
            inputChanged={inputChanged}
            imageSrc={imageSrc}
            dropdownOptions={dropdownOptions}
            edit={edit}
          />
        </Grid>
        <Grid container item spacing={1} direction={'column'}>
          <EmpPositions
            positions={empPositions}
            addRowClicked={addRowClicked}
            deleteRowClicked={deleteRowClicked}
            actionToClicked={actionToClicked}
            delegateClicked={delegateClicked}
            rowInputChanged={positionInputChanged}
            dropdownOptions={dropdownOptions}
            primaryRowIndex={primaryRowIndex}
            edit={edit}
          />
        </Grid>
      </Grid>
    </CardBody>
  )
}

export default empDetailBody
